import { Box, Stack, Tooltip, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { DataGrid } from "@mui/x-data-grid"

import { useParams, Link } from "react-router-dom"

import DeleteIcon from '@mui/icons-material/RemoveCircle';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import useFetch from "../../api/api"
import useAuth from "../../hooks/useAuth";

import { formatCurrency } 	from "../../common/Helper";
import ConfirmDialog 		from "../../components/ConfirmDialog";
import Subscribe 			from "../Subscription/views/Subscribe";
import config 				from "../../common/Config";
import QuoteRotator 		from "../../components/QuoteRotator";
import GeneralError from "../../components/GeneralError";
import RestrictedAccess from "../../components/RestrictedAccess";

const TabFilterResults = (props) => {

	const { screenerId }					= useParams()
	const {auth}							= useAuth()
	const privateFetch 						= useFetch()

	const [companies, setCompanies] 		= useState([])
	const [companyCount, setCompanyCount]	= useState()
	const [columns, setColumns]				= useState([])


	const [confirmOpen, setConfirmOpen]		= useState(false)
	const [confirmTicker, setConfirmTicker]	= useState()	
	const [isLoading, setIsLoading]			= useState(true)

	const systemColumns = [{
		field				: 'action', 
		headerName			: '', 
		width				: 10,
		disableColumnMenu 	: true,
		sortable 			: false,
		resizable			: false,
		align				: 'center',
		cellClassName		: "portfolio-grid-fixed-column",
		renderCell: (cellValues) => {
			if (cellValues.row.inPortfolio) {
				return <Tooltip title="Remover do portfolio"><DeleteIcon sx={{ fontSize: 15, color: 'red', cursor: 'pointer' }} nClick={() => handleConfirmRemove(cellValues.row.ticker)}/></Tooltip>
			}
			else {
				return <Tooltip title="Adicionar ao portfolio"><AddCircleIcon sx={{ fontSize: 15, color: 'green', cursor: 'pointer' }} onClick={() => handleAddTarget(cellValues.row.ticker)}/></Tooltip>
			}
		}
	},{
		field 				: 'ticker',
		headerName			: 'Ticker',
		sortComparator 		: (v1, v2) => v1 < v2 ? 1 : -1,
		renderCell : (c) => {
			return <Link to={`/company/${c.row.ticker}`} target='_blank'>{c.row.ticker}</Link>;
		},
		width				: 75,
		disableColumnMenu 	: true,
		align				: 'left',
		headerAlign			: 'left',
		cellClassName		: "portfolio-grid-fixed-column"
	}]

	const handleConfirmRemove = (ticker) => {
		setConfirmOpen(true)
		setConfirmTicker(ticker)
	}

	const handleRemoveTarget = () => {
		let options = {
			method : 'DELETE',
			headers : {
				'content-type' : 'application/json; charset=utf-8',
			}
		}

		privateFetch(config.apiUrl +"/api/portfolio/"+ confirmTicker, options)
		.then((data) => data.json())
		.then((data) => {
			setCompanies(prevState => {
				const oldPortfolio 	= [...prevState]
				const index 		= oldPortfolio.findIndex(p => p.ticker === confirmTicker)

				if (index >= 0) oldPortfolio[index].inPortfolio	= false
				return oldPortfolio
			})
		})
	}

	const handleAddTarget = (ticker) => {
		let options = {
			method : "POST",
			headers : {
				"Content-Type" : "application/json"	
			},
			body : `{ 
				"ticker" : "`+ ticker +`", 
				"target" : "0"
			}`
			
		}
		
		privateFetch(config.apiUrl +"/api/portfolio/addTarget", options)
		.then(result => {
			setCompanies(prevState => {
				const oldPortfolio	= [...prevState]
				const index 		= oldPortfolio.findIndex(p => p.ticker === ticker)
				oldPortfolio[index].inPortfolio = true
				return oldPortfolio
			})
		});
	}

	useEffect(() => {
		
		if (auth.userId && screenerId > 0) {
			privateFetch(config.apiUrl +"/api/screener/"+ screenerId +"/companies")
			.then((data) => data.json())
			.then((data) => {
				if (data.screener) {
					// Busca as colunas configuradas pelo usuário e por na ordenação configurada
					let userColumns = data.screener.fields.sort((a,b) => a.screenerFields.fieldOrder - b.screenerFields.fieldOrder).map(f => { 
						return {
							field 			: f.id,
							headerName		: f.label,
							sortComparator 	: (v1, v2) => f.type === 'numeric' ?  parseFloat(v1) - parseFloat(v2) : ( v1 < v2 ? 1 : -1 ),
							valueFormatter	: (value, row) => {
								switch (f.unit) {
									case 'currency' 	: return formatCurrency(value, 'SMALL', (f.category === 'FINANCIAL' || f.category === 'VALUATION') && !data.screener.convertToDollar ? row.currency : 'USD')
									case 'bigCurrency' 	: return formatCurrency(value, 'BIG', (f.category === 'FINANCIAL' || f.category === 'VALUATION') && !data.screener.convertToDollar ? row.currency : 'USD')
									case 'intNumber'	: return Math.round(value)
									case 'percent'		: return parseFloat(value).toFixed(2) +'%'
									case 'number'		: return parseFloat(value).toFixed(2)
								}
							}
						}
					})

					setCompanies(data.companies)
					setCompanyCount(data.count)
					setColumns(systemColumns.concat(userColumns))
				}

				setIsLoading(false)
			})
		}
		else {
			setIsLoading(false)
		}
	}, [screenerId])

	if (isLoading) 		return (<Box height={'100%'} width={'100%'} display="flex" justifyContent="center" alignItems="center"><QuoteRotator/></Box>)
	if (!auth.userId) 	return (<Box height={'100%'} width={'100%'} display="flex" justifyContent="center" alignItems="center"><RestrictedAccess message="Faça login para ver os resultados deste filtro."/></Box>)

	return (
		<Box paddingTop={1}>
			<ConfirmDialog
				title="Remover Ticker?"
				open={confirmOpen}
				setOpen={setConfirmOpen}
				onConfirm={() => handleRemoveTarget(confirmTicker)}
				>
				Tem certeza que deseja remover {confirmTicker} do portfolio?
			</ConfirmDialog>

			{ companyCount > 0 ? (
				<DataGrid
					autosizeOnMount
					rows={companies}
					getRowId={(row) => row.ticker} 
					columns={columns}
					slots={companies.length < companyCount ? {footer: CustomFooterCallToSubscribe} : null}
					slotProps={companies.length < companyCount ? {footer: {companyCount}} : null}
					initialState={{
						density: 'compact',
						pagination: { paginationModel: { pageSize: 15 } }
					}}
					pageSizeOptions={[15,30,50]}
				/>
			) : (
				<Stack height="100%" alignItems="center" justifyContent="center" spacing={1}>
					<Typography variant="subtitle1">Nenhum resultado</Typography>
					<Typography variant="body2" color="text.secondary">Limpe ou ajuste os filtros para ver dados.</Typography>
				</Stack>
			)}

		</Box>
	)
}

const CustomFooterCallToSubscribe = (props) => {
	return (
		<Box sx={{ p: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
			<Subscribe title={'Assine agora e veja todas as '+ props.companyCount +' companhias encontradas!'}/>
		</Box>
	)
}
export default TabFilterResults